import { Text } from '@chakra-ui/react'
import { getUser } from '@/lib/apiFetch'

/** An id kept for audits and enquiries: still selectable, but not competing for attention. */
export function MutedId({ label, value }: { label?: string; value: string }) {
  return (
    <Text as="span" fontSize="2xs" color="fg.subtle" fontFamily="mono" overflowWrap="anywhere">
      {label ? `${label}: ` : ''}
      {value}
    </Text>
  )
}

/**
 * The ledger records only the reviewer's sign-in id. The address is known for the
 * signed-in reviewer alone, so anyone else stays an id — kept, but quiet.
 */
export function ReviewerName({ decidedBy }: { decidedBy: string }) {
  const user = getUser()
  const email = user?.sub === decidedBy ? user.email : undefined
  return email ? (
    <>
      <Text as="span" color="fg">
        {email}
      </Text>{' '}
      <MutedId value={decidedBy} />
    </>
  ) : (
    <MutedId value={decidedBy} />
  )
}
